import { apiGet, apiPatch, apiPostFile } from '../config/api';

export const getDocumentRequests = (user) =>
  apiGet('/student-portal/document-requests', user);

export const markRequestRead = (user, requestId) =>
  apiPatch(`/student-portal/document-requests/${requestId}/read`, user);

export const uploadForRequest = (user, requestId, file) => {
  const formData = new FormData();
  formData.append('files', file);
  return apiPostFile(`/student-portal/document-requests/${requestId}/upload`, user, formData);
};
